/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface InitiatedCartPaymentDto
 */
export interface InitiatedCartPaymentDto {
    /**
     * 
     * @type {PaymentState}
     * @memberof InitiatedCartPaymentDto
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof InitiatedCartPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {CartDto}
     * @memberof InitiatedCartPaymentDto
     */
    cartDto?: CartDto;
    /**
     * 
     * @type {number}
     * @memberof InitiatedCartPaymentDto
     */
    paymentAmount: number;
    /**
     * 
     * @type {string}
     * @memberof InitiatedCartPaymentDto
     */
    requestId?: string;
}

/**
 * Check if a given object implements the InitiatedCartPaymentDto interface.
 */
export function instanceOfInitiatedCartPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "paymentAmount" in value;

    return isInstance;
}

export function InitiatedCartPaymentDtoFromJSON(json: any): InitiatedCartPaymentDto {
    return InitiatedCartPaymentDtoFromJSONTyped(json, false);
}

export function InitiatedCartPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatedCartPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
        'cartDto': !exists(json, 'cartDto') ? undefined : CartDtoFromJSON(json['cartDto']),
        'paymentAmount': json['paymentAmount'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
    };
}

export function InitiatedCartPaymentDtoToJSON(value?: InitiatedCartPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
        'cartDto': CartDtoToJSON(value.cartDto),
        'paymentAmount': value.paymentAmount,
        'requestId': value.requestId,
    };
}

